import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';

import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import type { CSSProperties } from 'react';

const toolTipStyle = { width: '100%' };
const nameStyle: CSSProperties = { width: '100%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' };

export const SmrGroupHeaderComponent: React.FC<IHeaderParams> = (props) => {
    const { displayName } = props;

    return (
        <TooltipWrapper message={displayName} style={toolTipStyle}>
            <div style={nameStyle}>{displayName}</div>
        </TooltipWrapper>
    );
};

SmrGroupHeaderComponent.displayName = 'SmrGroupHeaderComponent';
